import { render, staticRenderFns } from "./Freightcollect.vue?vue&type=template&id=38f91c5d&scoped=true"
import script from "./Freightcollect.vue?vue&type=script&lang=js"
export * from "./Freightcollect.vue?vue&type=script&lang=js"
import style0 from "./Freightcollect.vue?vue&type=style&index=0&id=38f91c5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f91c5d",
  null
  
)

export default component.exports